import RandingStyle1 from "../../randing/RandingStyle1";
import RandingStyle10 from "../../randing/RandingStyle10";

function Randing217({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/217/01.gif`}
      // img3Path={`${process.env.REACT_APP_CDN_BASE}/images/217/01.gif`}
      qTitleColor="#18646c"
      qOptionColor="teal"
      formFieldColor="white"
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/018/01_241120_04.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/018/02_241120_05.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori.jpg`}
    />
  );
}

export default Randing217;
